import { DeskControllerBase } from '../../DeskControllerBase';
import './attendantPermission.scss';
import { TeamConstants } from '../TeamConstants';
import { camelCaseToSnakeCase } from 'modules/shared/helpers/String';
import { AttendanceFeatures } from '../../AttendanceFeatures';
import { GeneralSettingsConstants } from 'modules/application/detail/attendance/generalsettings/GeneralSettingsConstants';
export class AttendantPermissionController extends DeskControllerBase {
    static $inject = ['application', 'DeskConfigurationService', 'LoadingService', '$scope', '$window', '$translate', 'AttendantPermissionService', 'SegmentService', 'BlipToastService'];
    constructor(application, DeskConfigurationService, LoadingService, $scope, $window, $translate, AttendantPermissionService, SegmentService, BlipToastService) {
        'ngInject';
        super(application, LoadingService, DeskConfigurationService, $scope);
        this.application = application;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.$scope = $scope;
        this.$window = $window;
        this.$translate = $translate;
        this.AttendantPermissionService = AttendantPermissionService;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.hasChanged = false;
        this.isLoading = false;
        this.isSaving = undefined;
        this.attendants = [];
        this.attendant = undefined;
        this.permissions = [];
        this.isPaymentLinkPermissionEnabled = false;
        this.isTransferAttendantPermissionEnabled = false;
        this.isCallsPermissionEnabled = false;
        this.isVideoCallsPermissionEnabled = false;
        this.isReceiveCallsPermissionEnabled = false;
        this.isContactHistoryEnabled = false;
        this.isCareCopilotEnabled = false;
        this.isTenantBotBlipCopilotEnabled = false;
        this.togglePermission = async (event) => {
            if (this.isSaving) {
                return;
            }
            const permissionName = event.detail.name;
            const permissionCheck = event.detail.checked;
            this.isSaving = permissionName;
            const attendantPermission = this.permissions.find(permission => permission.name === permissionName);
            attendantPermission.isActive = permissionCheck;
            try {
                const permissionNameSnakeCase = camelCaseToSnakeCase(permissionName).toUpperCase();
                const trackEventName = TeamConstants.TRACK_ATTENDANT_PERMISSION[permissionNameSnakeCase];
                if (this.attendant) {
                    await this.AttendantPermissionService.setAttendantPermissions(this.attendant.identity, [attendantPermission]);
                    this.SegmentService.createApplicationTrack({
                        trackEvent: trackEventName,
                        application: this.application,
                        payload: { isEnabled: event.detail.checked, attendantId: this.attendant.identity },
                    });
                }
                else {
                    await this.AttendantPermissionService.setAttendantsPermissions(this.attendants.map((at) => (at.identity)), [attendantPermission]);
                    Promise.all(this.attendants.map(async (at) => {
                        this.SegmentService.createApplicationTrack({
                            trackEvent: trackEventName,
                            application: this.application,
                            payload: { isEnabled: event.detail.checked, attendantId: at.email },
                        });
                    }));
                }
                const successMsg = await this.$translate('utils.successMsg.47');
                this.BlipToastService.show('success', { msg: successMsg });
                this.hasChanged = false;
            }
            catch (error) {
                attendantPermission.isActive = !permissionCheck;
                const errorMsg = await this.$translate('utils.errorMsg.180');
                this.BlipToastService.show('danger', { msg: errorMsg });
            }
            this.isSaving = undefined;
            if (!this.$scope.$$phase) {
                this.$scope.$apply();
            }
        };
    }
    async $onInit() {
        await this.checkFeatures();
        await this.checkDeskConfiguration();
        this.hasChanged = false;
        const attendantsStored = this.$window.sessionStorage.getItem(TeamConstants.ATTENDANTS_TO_PERMISSION_STORED);
        if (attendantsStored) {
            this.attendants = JSON.parse(attendantsStored);
            const firstAttendant = this.attendants[0];
            this.isSingleAttendant = this.attendants.length == 1;
            if (this.isSingleAttendant) {
                this.attendant = this.attendants[0];
                this.attendantsDescription = await this.$translate('singleMemberDescription', { firstAttendant: firstAttendant.fullName });
                await this.loadAttendantPermissions();
            }
            else {
                this.hasChanged = true;
                const countAttendants = this.attendants.length - 1;
                if (countAttendants > 1) {
                    this.attendantsDescription = await this.$translate('multiplesMembersDescription', { firstAttendant: firstAttendant.fullName, countOtherAttendants: countAttendants });
                }
                else {
                    const secondAttendant = this.attendants[1];
                    this.attendantsDescription = await this.$translate('coupleMembersDescription', { firstAttendant: firstAttendant.fullName, secondAttendant: secondAttendant.fullName });
                }
                await this.loadAvailableAttendantPermissions();
            }
        }
        await this.checkPermissionsWithFeatureToggle();
    }
    async checkFeatures() {
        this.isPaymentLinkPermissionEnabled = await AttendanceFeatures.isPaymentLinkPermissionEnabled();
        this.isTransferAttendantPermissionEnabled = await AttendanceFeatures.isTransferAttendantPermissionEnabled();
        this.isCallsPermissionEnabled = await AttendanceFeatures.isAttendantCallsPermissionEnabled();
        this.isVideoCallsPermissionEnabled = await AttendanceFeatures.isAttendantVideoCallsPermissionEnabled();
        this.isReceiveCallsPermissionEnabled = await AttendanceFeatures.isAttendantReceiveCallsPermissionEnabled();
        this.isContactHistoryEnabled = await AttendanceFeatures.isContactHistoryFeatureEnabled();
    }
    async checkDeskConfiguration() {
        this.isCareCopilotEnabled = await this.DeskConfigurationService.getDeskConfiguration(GeneralSettingsConstants.CARE_COPILOT_ENABLED);
        this.isTenantBotBlipCopilotEnabled = await this.DeskConfigurationService.getDeskConfiguration(GeneralSettingsConstants.TENANT_BOT_BLIP_COPILOT_ENABLED, false);
    }
    async loadAttendantPermissions() {
        this.isLoading = true;
        const { resource } = await this.AttendantPermissionService.getAttendantPermissions(this.attendant.identity);
        if (resource) {
            const attendantPermissions = resource.items;
            if (attendantPermissions) {
                this.permissions = attendantPermissions;
            }
        }
        this.isLoading = false;
    }
    async loadAvailableAttendantPermissions() {
        this.isLoading = true;
        const { resource } = await this.AttendantPermissionService.getAvailableAttendantPermissions();
        if (resource) {
            const availablePermissions = resource.items;
            if (availablePermissions) {
                this.permissions = availablePermissions;
            }
        }
        this.isLoading = false;
    }
    checkPermissionsWithFeatureToggle() {
        const disabledPermissions = [];
        if (!this.isPaymentLinkPermissionEnabled) {
            disabledPermissions.push('canViewAndCreatePaymentLink');
        }
        if (!this.isTransferAttendantPermissionEnabled) {
            disabledPermissions.push('canAttendantTransfer');
        }
        if (!this.isCallsPermissionEnabled) {
            disabledPermissions.push('canCallsVoiceOutbound');
        }
        if (!this.isVideoCallsPermissionEnabled) {
            disabledPermissions.push('canCallsVideo');
        }
        if (!this.isReceiveCallsPermissionEnabled) {
            disabledPermissions.push('canCallsVoiceInbound');
        }
        if (!this.isCareCopilotEnabled || !this.isTenantBotBlipCopilotEnabled) {
            disabledPermissions.push('canCareCopilotSummary');
            disabledPermissions.push('canCareCopilotSuggestions');
        }
        if (!this.isContactHistoryEnabled) {
            disabledPermissions.push('canAccessContactHistory');
        }
        if (disabledPermissions.length > 0) {
            this.permissions = this.permissions.filter((permission) => !disabledPermissions.includes(permission.name));
        }
    }
}
AttendantPermissionController.$inject = ['application', 'DeskConfigurationService', 'LoadingService', '$scope', '$window', '$translate', 'AttendantPermissionService', 'SegmentService', 'BlipToastService'];
